import { Injectable } from '@angular/core';
import { BaseService, ConfigService, IModelEntity, IUtilsDictionary, LoggingService, UtilsDictionary, UtilsMisc, UtilsString } from '@pit/core';
import { IEntityFacadesAccessorService } from '../interfaces/entity.facades.accessor.interface';
import { IEntityStoreFacade } from '../interfaces/entity.store.facae.interface';

@Injectable({
    providedIn: 'root'
})
export class EntityFacadesAccessorService extends BaseService implements IEntityFacadesAccessorService {

    protected _facades: IUtilsDictionary<any> = null;

    constructor(configService: ConfigService, loggingService: LoggingService) {
        super(configService, loggingService);

        loggingService.debug('EntityDataServiceAccessorService --> constructor()');
    }

    public getEntityFacade<T extends IModelEntity>(serviceName: string): IEntityStoreFacade<T> {
        let result: IEntityStoreFacade<T> = null;

        if (UtilsString.stringIsNullOrEmpty(serviceName) === false) {
            result = (this.facades.getValue(serviceName) as IEntityStoreFacade<T>);
        }

        return result;
    }

    public registerEntityFacade<T extends IModelEntity>(serviceName: string, entityFacade: IEntityStoreFacade<T>) {
        if ((UtilsString.stringIsNullOrEmpty(serviceName) === false) && (UtilsMisc.isNullOrUndefined(entityFacade) === false)) {
            this.facades.add(serviceName, entityFacade);
        }
    }

    protected get facades(): IUtilsDictionary<any> {
        if (this._facades === null) {
            this._facades = new UtilsDictionary<any>();
        }

        return this._facades;
    }

}
